import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTouchpadClick = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M15 11c-2.77 0-5.138 2.234-5 5l2 40c.138 2.767 2.23 5 5 5h16.771A20 20 0 0 1 27 46a20 20 0 0 1 20-20 20 20 0 0 1 20 20 20 20 0 0 1-6.772 15h22.771c2.77 0 4.862-2.233 5-5l2-40c.138-2.766-2.23-5-5-5h-70zm32 20a15 15 0 0 0-15 15 15 15 0 0 0 7.012 12.695V46c0-4.155 3.345-7.5 7.5-7.5h1c4.155 0 7.5 3.345 7.5 7.5v12.682A15 15 0 0 0 62 46a15 15 0 0 0-15-15m.012 11c-2.77 0-5 2.23-5 5v31.25l-3.836-3.836a6.237 6.237 0 0 0-8.84 0 6.235 6.235 0 0 0 0 8.838l12.375 12.375c.447.447.943.812 1.47 1.096a4.99 4.99 0 0 0 3.83 1.777h31.25c2.77 0 5-2.23 5-5V68.75a3.74 3.74 0 0 0-3.75-3.75h-2.5a3.74 3.74 0 0 0-3.741 3.5h-.008V68a3.74 3.74 0 0 0-3.75-3.75h-2.5a3.74 3.74 0 0 0-3.75 3.75v-.75a3.74 3.74 0 0 0-3.75-3.75h-2.5a3.74 3.74 0 0 0-3.75 3.75v1.25h-1.25V47c0-2.77-2.23-5-5-5"
	})
});
export default SvgTouchpadClick;
